import { AppConfigurationItemModel } from '../store.model';

export enum AppConfigurationActionTypes {
  STORE_APP_CONFIGURATION = 'STORE_APP_CONFIGURATION'
}

export interface StoreAppConfigurationAction {
  type: AppConfigurationActionTypes;
  payload: AppConfigurationItemModel[];
}

export const storeAppConfigurationAction = (
  items: AppConfigurationItemModel[]
): StoreAppConfigurationAction => {
  return { type: AppConfigurationActionTypes.STORE_APP_CONFIGURATION, payload: items };
};
